import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Navbar from "../components/Navbar/Navbar";
import EditExpenseReportItemForm from "./EditExpenseReportItemForm";
import { apiCall } from "../api/apiCall";
import { ExpenseReportItem } from "../models/expense_report_item";
import TopHeader from "../components/Navbar/TopHeader";

function EditExpenseReportItemPage() {
  const { uuid } = useParams<{ uuid: string }>();

  const {
    data: item,
    isLoading,
    isError,
    error,
  } = useQuery<ExpenseReportItem, Error>({
    queryKey: ["expense-report-item", uuid],
    queryFn: async () => {
      const items = await apiCall<ExpenseReportItem[]>(
        `/expense-reports/${uuid}/items`, 
        { method: "GET" }
      );
      
      return items[0];
    },
    enabled: !!uuid,
  });

  if (isLoading) {
    return (
      <>
        <Navbar />
        <TopHeader />
        <p style={{ paddingTop: "90px" }}>Chargement de la ligne de frais...</p>
      </>
    );
  }

  if (isError || !item) {
    return (
      <>
        <Navbar />
        <TopHeader />
        <p style={{ paddingTop: "90px", color: "red" }}>
          Erreur : {error?.message || "Ligne de frais introuvable"}
        </p>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <TopHeader />
      {/* L'item est maintenant un objet unique, le composant enfant sera content */}
      <EditExpenseReportItemForm item={item} />
    </>
  );
}

export default EditExpenseReportItemPage;